import { Component, HostListener, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { encryptWithKey } from '../../shared/models/helper';
import { Defaultconfig } from '../../shared/models/Defaultconfig';
import { Title } from '@angular/platform-browser';
import { CommunicationService } from '../../services/communication.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';
import { Utils } from 'src/app/shared/helpers/Utils';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  publicLoginInfo: any;
  loader: boolean = false;
  submitted = false;

  captcha = {
    enabled: false,
    site_key: '',
    verified: false,
    captcha_response: '', 
  };
  emailPattern: any = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/;
  mobilePattern: any = /^[0-9]{10}$/;
  loginForm: FormGroup = this.formBuilder.group({
    userType: [''],
    username: ['', Validators.required],
    mobile: ['', [Validators.required, Validators.pattern(this.mobilePattern)]],
    email: ['', [Validators.required, Validators.email, Validators.pattern(this.emailPattern)]],
    password: ['', [Validators.required]],
    remember_me: [false],
    captcha_response: [''],
  });
  request_id: string = '';
  view_type: string = '';
  client_id: string = '';
  flow_id: string = '';
  logo_uri: any;
  isRegisterEnabled: boolean = false;
  isPasswordlessEnabled: boolean = false;
  isShowRememberMe: boolean = false;
  isErrorOccured: boolean = false;
  errorDescription: any;
  internalError: string = '';
  userValueTypes: any[] = [];
  queryParams: any = {};
  textOrPassword: string = 'password';
  password: any;
  show: boolean = false;
  showEmail: boolean = false;
  showMobile: boolean = false;
  showUsername: boolean = false;
  isNumberInput: boolean = false;
  isMailInput: boolean = false;
  is_federation_login: boolean = false;
  singleLeggedSettings: string[] = [];
  isSingleLeggedEnabled: boolean = false;
  //Responsive
  viewType: any;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.viewType = Defaultconfig.checkHostListenerEvent(event);
  }
  login_hint: any;
  constructor(
    private formBuilder: FormBuilder,
    private activateRoute: ActivatedRoute,
    private renderer: Renderer2,
    private titleService: Title,
    private communicationService: CommunicationService,
    private router: Router
  ) {
    this.request_id = this.activateRoute.snapshot.queryParams['request_id'];
    this.client_id = this.activateRoute.snapshot.queryParams['client_id'];
    this.login_hint = this.activateRoute.snapshot.queryParams['login_hint'];
    let url: any = decodeURIComponent(this.login_hint).replace(/ /g, '+');
    //console.log('login_hint', decodeURIComponent(this.login_hint).replace(/ /g, '+'));
    if(this.login_hint) this.loginForm.controls['email'].setValue(url); 
  }

  ngOnInit(): void {
    this.getViewType(); //Responsive
    this.password = 'password';
    this.loader = true;
    this.communicationService.publicLoginInfo$.subscribe(data => {
      if (data && data != '') {
        this.loader = false;
        this.publicLoginInfo = data;
      }
      this.setLoginDetails();
      this.titleService.setTitle(this.publicLoginInfo?.display_settings?.display_name);
    });
    this.communicationService.queryParams$.subscribe((data: any) => (this.queryParams = data));
    this.internalError = this.activateRoute.snapshot.queryParams['internal_error'];
    this.captchaErrorCheck(this.internalError);
  }

  getViewType() {
    var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (width <= 767) {
      this.viewType = 'mobile';
    } else {
      this.viewType = 'desktop';
    }
    //console.log('type', this.viewType);
  }

  trackByFn(index: any, item: any) {
    return item.id;
  }

  get form() {
    return this.loginForm.controls;
  }

  setLoginDetails() {
    if (this.publicLoginInfo) {
      if (this.publicLoginInfo.enable_classical == false && this.publicLoginInfo.settings?.show_federation_login == true) {
        let url: any = Defaultconfig.getCurrentUrl() + '/federation-login?request_id=' + this.request_id + '&client_id=' + this.client_id;
        window.location.href = url;
      } else {
        this.is_federation_login = this.publicLoginInfo.settings?.show_federation_login;
        // this.logo_uri = Utils.convertToWebp(this.publicLoginInfo.display_settings?.logo_uri);
        this.logo_uri = this.publicLoginInfo.display_settings?.logo_uri;
        this.isRegisterEnabled = this.publicLoginInfo.settings?.show_register_option;
        this.isPasswordlessEnabled = this.publicLoginInfo.settings?.show_password_less_login;
        this.isShowRememberMe = this.publicLoginInfo.settings?.show_remember_me;
        this.userValueTypes = this.publicLoginInfo.allowed_username_types;
        this.showEmail = _.includes(this.userValueTypes, 'email');
        this.showMobile = _.includes(this.userValueTypes, 'mobile');
        this.showUsername = _.includes(this.userValueTypes, 'username');
        //console.log('Usernmae show=', this.showUsername);

        this.singleLeggedSettings = this.publicLoginInfo.single_legged_settings;
        if (this.singleLeggedSettings.length !== 0) {
          this.isSingleLeggedEnabled = true;
        }

        if (this.publicLoginInfo.captcha_settings && this.publicLoginInfo.captcha_settings.client_id && this.publicLoginInfo.captcha_settings.client_id != '') {
          this.captcha.site_key = this.publicLoginInfo.captcha_settings.client_id;
          if (this.internalError == 'captcha_required') {
            this.isErrorOccured = true;
            this.errorDescription = 'Captcha Required!';
            this.captcha.enabled = true;
          }
        }
      }
    }
  }

  singleRedirection() {
    const containsFace = this.singleLeggedSettings.includes('Face');
    const containsFIDO = this.singleLeggedSettings.includes('FIDO');

    if (containsFace && !containsFIDO && this.singleLeggedSettings.length === 1) {
      //console.log('Face..');
      this.router.navigate(['/otp-verification'], {
        queryParams: { request_id: this.request_id, client_id: this.client_id, mfa_type: 'FACE' },
      });
    } else if (!containsFace && containsFIDO && this.singleLeggedSettings.length === 1) {
      //console.log('fido');
      this.router.navigate(['/otp-verification'], {
        queryParams: { request_id: this.request_id, client_id: this.client_id, mfa_type: 'FIDO' },
      });
    } else if (containsFace && containsFIDO && this.singleLeggedSettings.length === 2) {
      this.router.navigate(['/single-legged'], {
        queryParams: { request_id: this.request_id, client_id: this.client_id },
      });
    } else {
      //console.log('invalid');
    }
  }

  captchaErrorCheck(internal_error: string) {
    if (internal_error == 'user_blocked') {
      this.isErrorOccured = true;
      this.errorDescription = 'Your account has been blocked temporarily due to too many attempts! please try again later or contact administrator!';
    } else {
      let error = this.activateRoute.snapshot.queryParams['error'];
      this.errorDescription = this.activateRoute.snapshot.queryParams['error_description'];
      if (error && (error == 'invalid_request' || error == 'invalid_username_password')) {
        this.isErrorOccured = true;
      }
    }
  }

  onLoginSubmit() {
    const postLoginURL = Defaultconfig.GetAuthBaseURL() + 'login-srv/login';
    const rememberMe = this.loginForm.get('remember_me')?.value;
    const form = this.renderer.createElement('form');
    form.action = postLoginURL;
    form.method = 'post';
    const usernameInput = this.renderer.createElement('input');
    usernameInput.name = 'enc_username';
    const rememberMeInput = this.renderer.createElement('input');
    rememberMeInput.name = 'remember_me';
    rememberMeInput.value = rememberMe.toString();
    this.renderer.appendChild(form, rememberMeInput);
    if (this.userValueTypes && this.userValueTypes.length) {
      if (this.showEmail && !(this.showMobile || this.showUsername)) {
        usernameInput.value = encryptWithKey(this.loginForm.get('email')?.value, this.queryParams.request_id);
      }
      if(this.showMobile && !(this.showEmail || this.showUsername)) {
        usernameInput.value = encryptWithKey(this.loginForm.get('mobile')?.value.toString(), this.queryParams.request_id);
      }
      if(this.showUsername && !(this.showEmail || this.showMobile)) {
        usernameInput.value = encryptWithKey(this.loginForm.get('username')?.value, this.queryParams.request_id);
      }
      if ((this.showEmail && this.showMobile) || (this.showEmail && this.showUsername) || (this.showMobile && this.showUsername)) {
        usernameInput.value = encryptWithKey(this.loginForm.get('username')?.value, this.queryParams.request_id);
      }
    } else {
      usernameInput.value = encryptWithKey(this.loginForm.get('email')?.value, this.queryParams.request_id);
    }
    const passwordInput = this.renderer.createElement('input');
    passwordInput.name = 'enc_password';
    passwordInput.value = encryptWithKey(this.loginForm.get('password')?.value, this.queryParams.request_id);
    const requestIdInput = this.renderer.createElement('input');
    requestIdInput.name = 'request_id';
    requestIdInput.value = this.queryParams.request_id;
    const providernameInput = this.renderer.createElement('input');
    providernameInput.name = 'provider_name';
    providernameInput.value = this.queryParams.provider_name;
    const providertypeInput = this.renderer.createElement('input');
    providertypeInput.name = 'provider_type';
    providertypeInput.value = this.queryParams.provider_type;
    this.renderer.appendChild(form, usernameInput);
    this.renderer.appendChild(form, passwordInput);
    this.renderer.appendChild(form, requestIdInput);
    if (this.queryParams.provider_name) {
      this.renderer.appendChild(form, providernameInput);
    }
    if (this.queryParams.provider_type) {
      this.renderer.appendChild(form, providertypeInput);
    }
    this.renderer.appendChild(document.body, form);
    form.submit();
    this.renderer.removeChild(document.body, form);
  }

  loginwithSocial(provider: any) {
    //console.log('ad', Defaultconfig.GetAuthBaseURL() + 'social-login-srv/init/' + provider.provider_name + '/login/' + this.request_id + '/AD');
    switch (provider?.provider_type) {
      case 'AD':
        window.location.href = Defaultconfig.GetAuthBaseURL() + 'social-login-srv/init/' + provider.provider_name + '/login/' + this.request_id + '/AD';
        break;
      case 'REST':
        window.location.href = Defaultconfig.GetAuthBaseURL() + 'social-login-srv/init/' + provider.provider_name + '/login/' + this.request_id + '/REST';
        break;
      default:
        window.location.href = Defaultconfig.GetAuthBaseURL() + 'social-login-srv/init/' + provider.provider_name + '/login/' + this.request_id;
        break;
    }
  }

  loginWithSaml(provider: any) {
    window.location.href = Defaultconfig.GetAuthBaseURL() + 'social-login-srv/init/' + provider + '/login/' + this.request_id + '/saml';
  }

  resolved(captchaResponse: any) {
    this.captcha.verified = true;
    //console.log(`Resolved captcha with response: ${captchaResponse}`);
    this.captcha.captcha_response = captchaResponse;
    this.loginForm.patchValue({
      captchaResponse: this.captcha.captcha_response,
    });
  }
  onClick() {
    if (this.password === 'password') {
      this.password = 'text';
      this.show = true;
    } else {
      this.password = 'password';
      this.show = false;
    }
  }

  getInput() {
    this.isNumberInput = this.startsWithNumber(this.form['username'].value);
    this.isMailInput = this.includesString(this.form['username'].value);
  }

  startsWithNumber(str: any) {
    return /^\d/.test(str);
  }

  includesString(str: any) {
    return /[a-zA-Z]/g.test(str);
  }

  valid(): any {
    const captchaVerified = !this.captcha.enabled || this.captcha.verified;
    if (this.userValueTypes && this.userValueTypes.length) {
      if (this.showEmail && !(this.showMobile || this.showUsername)) {
        if (this.form['email'].value && !this.form['email'].errors?.['pattern'] && this.form['password'].value && captchaVerified) {
          return true;
        }
      }
      if(this.showMobile && !(this.showEmail || this.showUsername)) {
        if (this.form['mobile'].value && !this.form['mobile'].errors?.['pattern'] && this.form['password'].value && captchaVerified) {
          return true;
        }
      }
      if(this.showUsername && !(this.showEmail || this.showMobile)) {
        if (this.form['username'].value && this.form['password'].value && captchaVerified) {
          // if (this.form['username'].value && !this.form['username'].errors?.['pattern'] && this.form['password'].value && captchaVerified) {
            return true;
          }
      }
      if (this.showEmail && this.showMobile) {
        if (this.form['username'].value && !this.form['username'].errors?.['pattern'] && this.form['password'].value && captchaVerified) {
          return true;
        }
      }
      if ((this.showEmail && this.showUsername) || (this.showMobile && this.showUsername)) {
        if (this.form['username'].value && this.form['password'].value && captchaVerified) {
          return true;
        }
      }
    } else {
      if (this.form['email'].value && !this.form['email'].errors?.['pattern'] && this.form['password'].value && captchaVerified) {
        return true;
      }
    }
    return false;
  }
}
